import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { URL_BACKEND } from "../api/url";
import { useLoginStore } from "../stores/useLoginStore";
import { elToast } from "../functions/alertas";

export const useLoginAdmin = () => {

    const navigate = useNavigate()

    const objLogueado = useLoginStore( state => state.objLogueado)
    const setObjLogueado = useLoginStore( state => state.setObjLogueado)
    const [mostrarBtnLogin, setMostrarBtnLogin] = useState( objLogueado.token ? false : true );
    const [casiObjLogueado, setCasiObjLogueado] = useState({})
    const [comprobandoPermisos, setComprobandoPermisos] = useState( false )

    // el de google
    function onLoginSuccess(res) {


        // console.log( tokenId );
        // console.log( res );

        // return

        var {
            email,
            familyName: apellido,
            givenName: nombre
        } = res.profileObj
        var token = res.tokenId;
        // email.substr(0, 2) === "20"
        // es pa dejar que lenin entre
        if ( false ) {
            alert("Personal no autorizado")
        } else {
            setCasiObjLogueado({ email, nombre, apellido, token })
        }

    }

    const onLoginFailure = error => {
        console.log(error);
        alert("Error. ¿Estás usando tu correo institucional?")
    }

    const traerPermisos = () => {

        // elToast( "Comprobando permisos", "esperar" );
        setComprobandoPermisos( true )
        setMostrarBtnLogin(false)

        var fd = new FormData()
        fd.append("funcion", "validarLogin")
        fd.append("token", casiObjLogueado.token)
        fd.append("email", casiObjLogueado.email)

        fetch( URL_BACKEND, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( function (d) {


            if (d.permitido) {

                let obj = {
                    ...casiObjLogueado,
                    carreras: d.permisos.carreras,
                    nivel: d.permisos.nivel
                }

                localStorage.setItem('user', JSON.stringify( obj ))
                setObjLogueado( obj )

                if ( d.permisos.nivel === 'ADMIN' ) {

                    // setMostrarBtnLogin(false)
                    navigate('/materias')

                } else if ( d.permisos.nivel === 'COORDINADOR' ) {

                    // setMostrarBtnLogin(false)
                    navigate('/coordinadores')

                } else {
                    alert("Sin permisos específicos")
                }

            } else {

                alert("Usuario no autorizado")
            }

        })
        .catch( () => {
            setComprobandoPermisos( false )
            setMostrarBtnLogin( true )
            elToast( 'Ocurrió un error al comprobar los permisos' , 'info2')
        })

    }

    useEffect(() => {
        // console.log("objlogueado");

        if (casiObjLogueado.nivel) {

            // console.log("local storage");
            localStorage.setItem('user', JSON.stringify(casiObjLogueado))
            // useNavigate()
            // aquí me quedé

        } else if (casiObjLogueado.token) {

            traerPermisos()

        }

    }, [ casiObjLogueado ]);


    useEffect(() => {


        // en cuanto carga se borra el localStorage y el store
        document.title = 'Iniciar sesión'

        localStorage.removeItem('user')
        setObjLogueado({
            email: null,
            nombre: null,
            nivel: null,
            apellido: null,
            token: null
        })
        setMostrarBtnLogin(true)

        // let a = document.querySelector('')
        // a.parentNode.removeChild( a )

        // waitForElm('#close').then((elm) => {
        //     console.log('apareció la alerta');
        //     console.log(elm.textContent);
        // });


    }, [])

    return {
        onLoginSuccess,
        onLoginFailure,
        mostrarBtnLogin,
        objLogueado,
        comprobandoPermisos
    }
}
